import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { fetchApi } from '../../services/api';
import DisplayAddress from '../DisplayAddress';
import { LeadData } from './Profile';
import { MedicalData } from './ChildMedical';
import { JsonForm } from '../Forms/jsonForm';
import { GuardianViewModel } from '../Registration/Guardian';
import { ReleaseViewModel } from '../Registration/Release';

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    isLoading: boolean;
    index: number;
    print: LeadData|undefined;
    medical: MedicalData|undefined;
    medicalForm: JsonForm|undefined;
    guardians: GuardianViewModel[];
    guardiansForm: JsonForm|undefined;
    releases: ReleaseViewModel[];
    releasesForm: JsonForm|undefined;
    Validation: boolean;
    Selected: number;
    academicUser: boolean;
}

export default class ChildPrint extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            print: undefined,
            medical: undefined,
            medicalForm: undefined,
            guardians: [],
            guardiansForm: null,
            releases: [],
            releasesForm: null,
            index: 0,
            Validation: false,
            Selected: 0,
            academicUser: false,
        }

        this.Height = this.Height.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestPrint(childId);
    }

    public render() {
        return <div>
            {this.state.print &&
                <form className="k-form">
                    <h5>Child information</h5>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Facility:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{this.state.print.Facilities.filter(x => x.FacilityId === this.state.print.FacilityID)[0].Name}</p>
                                    </div>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Name:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{this.state.print.FirstName} {this.state.print.LastName}</p>
                                    </div>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Gender:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{this.state.print.Gender === 0 ? "Male" : "Female"}</p>
                                    </div>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Date of Birth:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{moment(this.state.print.BirthDate).format("MM/DD/YYYY")}</p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Home Phone Number:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{this.state.print.Phone}</p>
                                    </div>
                                    <h6>Home Address:</h6>
                                    <DisplayAddress address={this.state.print.HomeAddress}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(this.state.print.HasBreakfast || this.state.print.HasLunch || this.state.print.HasSnack || this.state.print.NapOne1 || this.state.print.NapOne2 || this.state.print.NapTwo1 || this.state.print.NapTwo2 || this.state.print.NapThree1 || this.state.print.NapThree2 || this.state.print.BottleOne || this.state.print.BottleTwo || this.state.print.BottleThree) &&
                        !this.state.academicUser && <div>
                            <br/>
                            <h5>Infant Daily Schedule</h5>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            {(this.state.print.HasBreakfast || this.state.print.HasLunch || this.state.print.HasSnack) &&
                                                <div>
                                                    <h6>Eating Schedule</h6>
                                                    <br/>
                                                    {this.state.print.HasBreakfast &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span>Breakfast:&nbsp;</span>
                                                            </div>
                                                            {this.state.print.Breakfast &&
                                                                <p>{this.state.print.Breakfast}</p>
                                                            }
                                                        </div>
                                                    }
                                                    {this.state.print.HasLunch &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span>Lunch:&nbsp;</span>
                                                            </div>
                                                            {this.state.print.Lunch &&
                                                                <p>{this.state.print.Lunch}</p>
                                                            }
                                                        </div>
                                                    }
                                                    {this.state.print.HasSnack &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span>Snack:&nbsp;</span>
                                                            </div>
                                                            {this.state.print.Snack &&
                                                                <p>{this.state.print.Snack}</p>
                                                            }
                                                        </div>
                                                    }
                                                    {this.state.print.HasSnack && <br/>}
                                                </div>
                                            }
                                            {(this.state.print.BottleOne || this.state.print.BottleTwo || this.state.print.BottleThree) &&
                                                <div>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span>Bottle Times:&nbsp;&nbsp;</span>
                                                        </div>
                                                        {this.state.print.BottleOne && <p>{this.state.print.BottleOne}</p>}
                                                        {this.state.print.BottleOne && (this.state.print.BottleTwo || this.state.print.BottleThree) && <p>, &nbsp;</p>}
                                                        {this.state.print.BottleTwo && <p>{this.state.print.BottleTwo}</p>}
                                                        {this.state.print.BottleTwo && this.state.print.BottleThree && <p>, &nbsp;</p>}
                                                        {this.state.print.BottleThree && <p>{this.state.print.BottleThree}</p>}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            {(this.state.print.NapOne1 || this.state.print.NapOne2 || this.state.print.NapTwo1 || this.state.print.NapTwo2 || this.state.print.NapThree1 || this.state.print.NapThree2) &&
                                                <div>
                                                    <h6>Nap Times:</h6>
                                                    <br/>
                                                    {
                                                        (this.state.print.NapOne1 || this.state.print.NapOne2) &&
                                                        <div className="input-group">
                                                            <p className="form-control-static" style={{paddingRight: 15}}>{this.state.print.NapOne1}</p>
                                                            <div className="input-group-prepend">
                                                                <span>-</span>
                                                            </div>
                                                            <p className="form-control-static" style={{paddingLeft: 15}}>{this.state.print.NapOne2}</p>
                                                        </div>
                                                    }
                                                    {
                                                        (this.state.print.NapTwo1 || this.state.print.NapTwo2) &&
                                                        <div className="input-group">
                                                            <p className="form-control-static" style={{paddingRight: 15}}>{this.state.print.NapTwo1}</p>
                                                            <div className="input-group-prepend">
                                                                <span>-</span>
                                                            </div>
                                                            <p className="form-control-static" style={{paddingLeft: 15}}>{this.state.print.NapTwo2}</p>
                                                        </div>
                                                    }
                                                    {
                                                        (this.state.print.NapThree1 || this.state.print.NapThree2) &&
                                                        <div className="input-group">
                                                            <p className="form-control-static" style={{paddingRight: 15}}>{this.state.print.NapThree1}</p>
                                                            <div className="input-group-prepend">
                                                                <span>-</span>
                                                            </div>
                                                            <p className="form-control-static" style={{paddingLeft: 15}}>{this.state.print.NapThree2}</p>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.guardiansForm && this.state.guardians.map((guardian) => {
                        return(
                            <div>
                                <br/>
                                <h5>Guardian's Information</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span>Relation to Child:&nbsp;</span>
                                                    </div>
                                                    <p className="input-group-static">{guardian.Relation}</p>
                                                </div>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span>Name:&nbsp;</span>
                                                    </div>
                                                    <p className="input-group-static">{guardian.FirstName} {guardian.LastName}</p>
                                                </div>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span>Cell Phone Number:&nbsp;</span>
                                                    </div>
                                                    <p className="input-group-static">{guardian.MobilePhone}</p>
                                                </div>
                                                {(guardian.WorkPhone) &&
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span>Work Phone Number:&nbsp;</span>
                                                        </div>
                                                        <p className="input-group-static">
                                                            {guardian.WorkPhone}
                                                            {guardian.WorkPhoneExtension && ` Ext. ${guardian.WorkPhoneExtension}`}
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                {(guardian.WorkName) &&
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span>Employer:&nbsp;</span>
                                                        </div>
                                                        <p className="input-group-static">{guardian.WorkName}</p>
                                                    </div>
                                                }
                                                {guardian.WorkAddress &&
                                                    <div>
                                                        <h6>Work Address:</h6>
                                                        <DisplayAddress address={guardian.WorkAddress}/>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {this.state.releasesForm && this.state.releases.map((release) => {
                        return(
                            <div>
                                <br/>
                                <h5>Releases's Information</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span>Relation to Child:&nbsp;</span>
                                                    </div>
                                                    <p className="input-group-static">{release.Relation}</p>
                                                </div>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span>Name:&nbsp;</span>
                                                    </div>
                                                    <p className="input-group-static">{release.FirstName} {release.LastName}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span>Cell Phone Number</span>
                                                    </div>
                                                    <p className="input-group-static">{release.MobilePhone}</p>
                                                </div>
                                                {(release.Phone) &&
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span>Phone Number</span>
                                                        </div>
                                                        <p className="input-group-static">{release.Phone}</p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <br/>
                    {this.state.medicalForm && this.state.medical && <div>
                        <h5>Medical Information</h5>
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h6>Doctor's Information</h6>
                                        <br/>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span>Name:&nbsp;</span>
                                            </div>
                                            <p className="input-group-static">{this.state.medical.DoctorFirstName} {this.state.medical.DoctorLastName}</p>
                                        </div>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span>Phone Number:&nbsp;</span>
                                            </div>
                                            <p className="input-group-static">{this.state.medical.DoctorPhone}</p>
                                        </div>
                                        {this.state.medical.DoctorAddress && <div>
                                            <h6>Doctor's Address:</h6>
                                            <DisplayAddress address={this.state.medical.DoctorAddress} />
                                        </div>}
                                        <div className="form-group">
                                            <div className="form-group">
                                                {(this.state.medical.HasDisability || this.state.medical.HasChronic || this.state.medical.HasDisorder || this.state.medical.HasMedication || this.state.medical.HasAllergies || this.state.medical.HasDietary) && <div>
                                                    <br/>
                                                    <h6>Health Issues:&nbsp;</h6>
                                                    <br/>
                                                    {this.state.medical.HasDisability &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <p>Disabilities:&nbsp;</p>
                                                            </div>
                                                            {this.state.medical.HasDisability && this.state.medical.Disability && <div>
                                                                <p>{this.state.medical.Disability}</p>
                                                            </div>}
                                                        </div>
                                                    }
                                                    {this.state.medical.HasChronic &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <p>Chronic Health Problems:&nbsp;</p>
                                                            </div>
                                                            {this.state.medical.HasChronic && this.state.medical.Chronic && <div>
                                                                <p>{this.state.medical.Chronic}</p>
                                                            </div>}
                                                        </div>
                                                    }
                                                    {this.state.medical.HasDisorder &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <p>Disorders:&nbsp;</p>
                                                            </div>
                                                            {this.state.medical.HasDisorder && this.state.medical.Disorder && <div>
                                                                <p>{this.state.medical.Disorder}</p>
                                                            </div>}
                                                        </div>
                                                    }
                                                    {this.state.medical.HasMedication &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <p>Medication:&nbsp;</p>
                                                            </div>
                                                            {this.state.medical.HasMedication && this.state.medical.Medication && <div>
                                                                <p>{this.state.medical.Medication}</p>
                                                            </div>}
                                                        </div>
                                                    }
                                                    {this.state.medical.HasAllergies &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <p>Allergies:&nbsp;</p>
                                                            </div>
                                                            {this.state.medical.HasAllergies && this.state.medical.Allergies && <div>
                                                                <p>{this.state.medical.Allergies}</p>
                                                            </div>}
                                                        </div>
                                                    }
                                                    {this.state.medical.HasDietary &&
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <p>Dietary Restrictions:&nbsp;</p>
                                                            </div>
                                                            {this.state.medical.HasDietary && this.state.medical.Dietary && <div>
                                                                <p>{this.state.medical.Dietary}</p>
                                                            </div>}
                                                        </div>
                                                    }
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span>Health Card Number:&nbsp;</span>
                                            </div>
                                            <p className="input-group-static">{this.state.medical.Healthcard}</p>
                                        </div>
                                        {!!this.state.medical.Height &&
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span>Height:&nbsp;</span>
                                                </div>
                                                {this.state.medical.HeightUnitOfMeasure === 0 && <p className="input-group-static">{Math.round(this.state.medical.Height) + " cm"}</p>}
                                                {this.state.medical.HeightUnitOfMeasure === 1 && <p className="input-group-static">{this.state.medical.HeightUnitOfMeasure === 1 && Math.floor(this.state.medical.Height * 0.393700 / 12)}ft {this.Height()}inches</p>}
                                            </div>
                                        }
                                        {!!this.state.medical.Weight &&
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span>Weight:&nbsp;</span>
                                                </div>
                                                <p className="input-group-static">{this.state.medical.Weight} {this.state.medical.WeightUnitOfMeasure === 0 ? "Kg" : "Lbs"}</p>
                                            </div>
                                        }
                                        {(this.state.medical.HasMeasles || this.state.medical.HasChickenPox || this.state.medical.HasScarletFever || this.state.medical.HasGermanMeasles || this.state.medical.HasWhoopingCough || this.state.medical.HasOther) && <div>
                                            <br/>
                                            <h6>Communicable Dieseases:&nbsp;</h6>
                                            <br/>
                                            {this.state.medical.HasMeasles &&
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <p>Measles</p>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.medical.HasChickenPox &&
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <p>ChickenPox</p>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.medical.HasScarletFever &&
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <p>ScarletFever</p>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.medical.HasGermanMeasles &&
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <p>German Measles</p>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.medical.HasWhoopingCough &&
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <p>Whopping Cough</p>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.medical.HasOther &&
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <p>Other:&nbsp;</p>
                                                    </div>
                                                {this.state.medical.HasOther && this.state.medical.Other && <div>
                                                    <p>{this.state.medical.Other}</p>
                                                </div>}
                                            </div>
                                            }
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    <br/>
                    <h5>Emergency Contact</h5>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Relation to Child:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{this.state.print.EmergencyRelation}</p>
                                    </div>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Name:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{this.state.print.EmergencyFirstName} {this.state.print.EmergencyLastName}</p>
                                    </div>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span>Phone Number:&nbsp;</span>
                                        </div>
                                        <p className="input-group-static">{this.state.print.EmergencyPhone}</p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    {this.state.print.EmergencyAddress &&
                                        <div>
                                            <h6>Emergency Address:</h6>
                                            <DisplayAddress address={this.state.print.EmergencyAddress}/>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            }
        </div>;
    }

    private requestPrint(printId: number) {
        const task1 = fetchApi(`api/Children/Print/${printId}`)
            .then((response: {
                    Child: LeadData,
                    Releases: ReleaseViewModel[],
                    ReleaseForm: JsonForm|undefined,
                    Guardians: GuardianViewModel[],
                    GuardianForm: JsonForm|undefined,
                    MedicalForm: JsonForm|undefined,
                    AcademicUser: boolean
                }) => {
                response.Child.BirthDate = response.Child.BirthDate ? moment.utc(response.Child.BirthDate).toDate() : null;
                response.Child.NapOne1 = response.Child.NapOne1 ? moment.utc(response.Child.NapOne1).toDate() : null;
                response.Child.NapOne2 = response.Child.NapOne2 ? moment.utc(response.Child.NapOne2).toDate() : null;
                response.Child.NapTwo1 = response.Child.NapTwo1 ? moment.utc(response.Child.NapTwo1).toDate() : null;
                response.Child.NapTwo2 = response.Child.NapTwo2 ? moment.utc(response.Child.NapTwo2).toDate() : null;
                response.Child.NapThree1 = response.Child.NapThree1 ? moment.utc(response.Child.NapThree1).toDate() : null;
                response.Child.NapThree2 = response.Child.NapThree2 ? moment.utc(response.Child.NapThree2).toDate() : null;
                response.Child.BottleOne = response.Child.BottleOne ? moment.utc(response.Child.BottleOne).toDate() : null;
                response.Child.BottleTwo = response.Child.BottleTwo ? moment.utc(response.Child.BottleTwo).toDate() : null;
                response.Child.BottleThree = response.Child.BottleThree ? moment.utc(response.Child.BottleThree).toDate() : null;
                this.setState({
                    print: response.Child,
                    releases: response.Releases,
                    releasesForm: response.ReleaseForm,
                    guardians: response.Guardians,
                    guardiansForm: response.GuardianForm,
                    medicalForm: response.MedicalForm,
                    academicUser: response.AcademicUser
                });
            });
        const task2 = fetchApi(`api/ChildMedical/Get/${printId}`)
            .then((medical: MedicalData) => {
                this.setState({ medical })
            });
        Promise.all([task1, task2]).then(() => {
            window.print();
            this.props.history.push(`/child/${this.state.print.ChildId}`);
        })
    }

    public Height() {
        if(this.state.medical){
            const realFeet = ((this.state.medical.Height * 0.393700) / 12);
            return Math.round((realFeet - Math.floor(realFeet)) * 12);
        }
    }
}
